<ul class="navigation-list" #navigation>
  <li
    *ngFor="let item of items; let index = index"
    class="navigation-list-item"
    [class.active]="activeIndex === index"
    (click)="indexChange.emit(index)"
  >
    <div class="navigation-dot-item"></div>
  </li>
</ul>
